
              import "_sentry-module-metadata-injection-stub";
              import * as OriginalModule from "/var/www/vhosts/roh_production/reviveourhearts_com/public/static/js/app/global.399b3441a7fc.js";
              export default OriginalModule.default;
              export * from "/var/www/vhosts/roh_production/reviveourhearts_com/public/static/js/app/global.399b3441a7fc.js";